/**
 * Deep-assign a dot-notated `key` into `obj`
 *
 * @example
 * let foo = { a: 1 };
 * deepAssign(foo, 'b.c', 2);
 * // foo === { a: 1, b: { c: 2 } }
 *
 * @param {Object} obj The object to be mutated/assigned into
 * @param {String} key The dot notated key that specifies the location to deep-assign `value`
 * @param {*} value The value to set at the location of `key`
 * @returns {Object} `obj` mutated
 */
export default function deepAssign(obj, key, value) {
	let keys = key.split('.');

	obj[keys[0]] = keys.length > 1
		? deepAssign(obj[keys[0]] || {}, keys.slice(1).join('.'), value)
		: value;

	return obj;
}
